import { Component, EventEmitter, inject, input, Input, OnChanges, OnInit, output, Output, ChangeDetectionStrategy } from '@angular/core';
import { DialogService, IconContext } from '@eforall/dashboard';
import { Venue } from '@interfaces';
import { VenueDialog } from '../venue.dialog';
import { CommonIconTextWidget } from '@eforall/common';
import { NgClass } from '@angular/common';


const CHOOSE_VENUE_ICON: IconContext = { text: "Choose a Venue", iconStyle: 'fa-regular', iconClass: "fa-map-marker-question", hideText: 'always' };


@Component({
	selector: 'venue-button',
	standalone: true,
	imports: [CommonIconTextWidget,
		NgClass,
	],
	templateUrl: './venue-button.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./venue-button.part.scss']
})
export class VenueButtonPart implements OnInit {

	public dialogService = inject(DialogService);

	public venue = input<{ venueId: number, displayedName: string } | undefined>(undefined);
	public buttonClass = input<string>('');
	public selection = output<{ venueId: number, displayedName: string }>();

	icon: IconContext = CHOOSE_VENUE_ICON;


	ngOnInit() {
		if (this.venue()) this.icon = { text: this.venue()!.displayedName, iconStyle: 'fa-regular', iconClass: "fa-map-marker-alt", hideText: 'never' };
		this.configure(this.venue());
	}


	async showDialog() {

		const action = await this.dialogService.showCustom(
			VenueDialog,
			{
				data: { venueId: this.venue()?.venueId },
			},
			650, 550);


		this.configure(action?.callbackResult);
	}



	configure(venue: { venueId: number, displayedName: string } | undefined) {

		if (venue) {
			if (this.venue()?.venueId !== venue?.venueId) {
				this.icon = { text: venue.displayedName, iconStyle: 'fa-regular', iconClass: "fa-map-marker-alt", hideText: 'never' };
				this.selection.emit(venue);
			}
		}
	}
}